const ExportNotificationHook = {
  mounted() {
    this.handleEvent("show-export-notification", ({type, title, message, download_url}) => {
      this.showNotification(type, title, message, download_url);
    });
  },

  showNotification(type, title, message, downloadUrl) {
    const existing = document.getElementById('export-notification-overlay');
    if (existing) existing.remove();
    
    const overlay = document.createElement('div');
    overlay.id = 'export-notification-overlay';
    overlay.className = 'fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[99999] opacity-0 transition-opacity duration-300';
    
    const borderColor = type === 'success' ? 'border-green-500' : 'border-red-500';
    const iconColor = type === 'success' ? 'text-green-500' : 'text-red-500';
    
    const icon = type === 'success' 
      ? `<svg class="w-12 h-12 flex-shrink-0 ${iconColor}" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`
      : `<svg class="w-12 h-12 flex-shrink-0 ${iconColor}" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`;
    
    overlay.innerHTML = `
      <div class="bg-white rounded-xl shadow-2xl max-w-lg w-[90%] p-6 transform scale-90 transition-transform duration-300 ${borderColor} border-l-[5px]">
        <div class="flex items-start gap-4 mb-5">
          ${icon}
          <div class="flex-1">
            <h3 class="text-xl font-semibold text-gray-900 mb-2">${title}</h3>
            <p class="text-sm text-gray-600">${message}</p>
          </div>
        </div>
        <div class="flex gap-3 justify-end">
        ${downloadUrl ? `<button onclick="
                const a = document.createElement('a');
                a.href = '${downloadUrl}';
                a.target = '_blank';
                a.click();
                document.getElementById('export-notification-overlay').remove();
              " class="px-5 py-2.5 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-sm font-semibold transition-colors">Download Now</button>` : ''}
          <button onclick="document.getElementById('export-notification-overlay').remove()" class="px-5 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-sm font-semibold transition-colors">
            ${downloadUrl ? 'Later' : 'Close'}
          </button>
        </div>
      </div>
    `;
    
    document.body.appendChild(overlay);
    
    setTimeout(() => {
      overlay.classList.remove('opacity-0');
      overlay.querySelector('div').classList.remove('scale-90');
      overlay.querySelector('div').classList.add('scale-100');
    }, 10);
    
    setTimeout(() => {
      if (document.getElementById('export-notification-overlay')) {
        overlay.classList.add('opacity-0');
        overlay.querySelector('div').classList.add('scale-90');
        setTimeout(() => overlay.remove(), 300);
      }
    }, 10000);
  }
};

export default ExportNotificationHook;